import React from "react";
import { Link } from "react-router-dom";
import { useShowUserMenu } from "../context/ShowUserMenuContext";

const UserMenu = () => {
  const { setShowUserMenu } = useShowUserMenu();
  return (
    <nav
      className={`main-menu main-menu-two clearfix`}
      style={{ marginTop: "71px" }}
    >
      <div className="main-menu-two-wrapper clearfix">
        <div className="container clearfix">
          <div className="main-menu-two-wrapper-inner clearfix">
            <div className="main-menu-two-wrapper__main-menu">
              <Link
                to="#"
                className="mobile-nav__toggler"
                onClick={() => {
                  setShowUserMenu(true);
                }}
              >
                <i className="fa fa-bars"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default UserMenu;
